'use strict';
define([
    'angular',
    'modules/keywordexplorer/landing/landing.controller'
], function (angular, KeywordLandingCtrl) {
    var app = angular.module('app.keywordexplorer.landing', []);
    app.controller('KeywordLandingCtrl', KeywordLandingCtrl);
    return app;
});
